// import { StylesProvider } from '@material-ui/core/styles'
import * as Sentry from '@sentry/browser'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import AppContextProvider from './app-context'
import { ToastProvider } from './components/ui/toast'
import reportWebVitals from './reportWebVitals'
import AppRouter from './routers/AppRouter'
import configureStore from './store/configureStore'
import './index.css'
import 'candi-borobudur/dist/styles/main.css'

const store = configureStore()

Sentry.init({ dsn: process.env.REACT_APP_SENTRY })

const AppRouterComponent = AppRouter as unknown as React.ComponentType<any>
const ProviderComponent = Provider as unknown as React.ComponentType<any>

const app = (
  <ProviderComponent store={store}>
    <ToastProvider>
      <AppContextProvider>
        <AppRouterComponent />
      </AppContextProvider>
    </ToastProvider>
  </ProviderComponent>
)

ReactDOM.render(app, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
